import { render, staticRenderFns } from "./MensajeInicial.vue?vue&type=template&id=0f333ce4&scoped=true"
import script from "./MensajeInicial.vue?vue&type=script&lang=js"
export * from "./MensajeInicial.vue?vue&type=script&lang=js"
import style0 from "./MensajeInicial.vue?vue&type=style&index=0&id=0f333ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f333ce4",
  null
  
)

export default component.exports